const options = {
  5: "bg-lime-500/5",
  10: "bg-lime-500/10",
  25: "bg-lime-500/25",
  50: "bg-lime-500/50",
  75: "bg-lime-500/75",
  90: "bg-lime-500/90",
  100: "bg-lime-500",
};

const from = {
  5: "from-lime-500/5",
  10: "from-lime-500/10",
  25: "from-lime-500/25",
  50: "from-lime-500/50",
  75: "from-lime-500/75",
  90: "from-lime-500/90",
  100: "from-lime-500",
};

export default function getBackgroundLime500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
